export const C_GREEN = '#17a673';
export const C_RED = '#d52a1a';
export const C_BLACK = '#42444e';
export const C_YELLOW = '#f6c23e';
export const C_BLUE = '#007bff';